<div class="mt-4 mb-3 row">
  <div class="col-sm-6 col-lg-3 mb-2">
    <span class="mr-2">Застройщиков на витрине:</span>
    <b class="text-large">{{ summary['on_showcase']['developers'] }}</b>
    @if (summary['on_showcase']['developers_not_fill']) {
      <span class="text-large mx-2">/</span>
      <b class="text-danger text-large mr-2">{{ summary['on_showcase']['developers_not_fill'] }}</b
        >не заполнено
      }
    </div>
    <div class="col-sm-6 col-lg-3 mb-2">
      <span class="mr-2">Застройщики, скоро завершится срок:</span>
      <b [class.text-warning]="summary['on_showcase']['developers_ends_soon']"
      class="text-large">{{ summary['on_showcase']['developers_ends_soon'] }}</b>
    </div>
    <div class="col-sm-6 col-lg-3 mb-2">
      <span class="mr-2">ЖК на витрине:</span>
      <b class="text-large">{{ summary['on_showcase']['complexes'] }}</b>
      @if (summary['on_showcase']['complexes_not_fill']) {
        <span class="text-large mx-2">/</span>
        <b class="text-danger text-large mr-2">{{ summary['on_showcase']['complexes_not_fill'] }}</b
          >не заполнено
        }
      </div>
      <div class="col-sm-6 col-lg-3 mb-2">
        <span class="mr-2">ЖК, скоро завершится срок:</span>
        <b [class.text-warning]="summary['on_showcase']['complexes_ends_soon']"
        class="text-large">{{ summary['on_showcase']['complexes_ends_soon'] }}</b>
      </div>
    </div>

    @if (summary['errors'].length) {
      <div class="mb-3">
        <app-alert-danger>
          <h5>Ошибки:</h5>
          <ul class="ml-3 mb-0">
            @for (err of summary['errors']; track err) {
              <li>
                @if (err?.complex_id) {
                  <a [routerLink]="['/housing2', 'complex', err.complex_id, 'edit', 'common']">{{ err.caption }}</a>
                }
                @if (!err?.complex_id) {
                  {{ err.caption }}
                }
              </li>
            }
          </ul>
        </app-alert-danger>
      </div>
    }

    <div class="mb-2">
      <div>
        Всего: <b>{{count}}</b>
      </div>
    </div>
    <div class="material-datatable-wrapper">
      <div class="table-responsive">
        <table class="table table-striped datatable table-rwd">
          <thead>
            <tr>
              @for (el of head; track el) {
                <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                  <div [formGroup]="form">
                    <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                      <div class="col table__input">
                        @if (el.input) {
                          <app-material-input
                            [placeholder] = "el.caption"
                            [formControlName] = "el.name"
                            [cssClass]="'mb-0'">
                          </app-material-input>
                        }
                        @if (el.select) {
                          <app-material-select
                            [formControlName]="el.name"
                            [cssClass]="'mb-0'"
                            [placeholder]="el.caption"
                            >
                            @for (opt of el.select; track opt) {
                              <option [value]="opt.id">{{opt.caption}}</option>
                            }
                          </app-material-select>
                        }
                        @if (!el.input && !el.select) {
                          {{el.caption}}
                        }
                      </div>
                      @if (el.sort) {
                        <div class="col-auto">
                          <a href="javascript:void(0)" (click)="sortChange(el.name)">
                    <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                        'icon_new-sort-down': 'asc' == sort[el.name],
                                        'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                          </a>
                        </div>
                      }
                    </div>
                  </div>
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row; let row_index = $index) {
              <tr
                >
                <td
                  [class.table-danger]="row['developer_is_danger']"
                  [class.table-warning]="row['developer_is_warning']"
                  >
                  <a [routerLink]="[row.id]">
                    @if (row['developer_is_danger']) {
                      <i class="mr-1 text-danger fa fa-fw fa-exclamation-triangle" title="УВ не показаны в ТК!"></i>
                    }
                    @if (row['developer_is_warning']) {
                      <i class="mr-1 text-warning fa fa-fw fa-exclamation-triangle" title="Скоро истечёт срок!"></i>
                    }
                    <span>{{ row['developer_caption'] }}</span>
                  </a>
                </td>
                @if (row.developer_date_to) {
                  <td
                    [class.table-danger]="row['developer_is_danger']"
                    [class.table-warning]="row['developer_is_warning']"
                    >
                    @if (row.developer_conditions_text) {
                      <popover-content #popoverInfo
                        [title]="'Условия выплат'"
                        [placement]="'auto'"
                        [closeOnClickOutside]="true"
                        [closeOnMouseOutside]="false">
                        <p class="mb-0">
                          {{row.developer_conditions_text}}
                        </p>
                      </popover-content>
                      <div [popover]="popoverInfo">
                        <i class="fa fa-fw fa-question-circle c-pointer text-danger"></i>
                      </div>
                    }
                    @if (!row.developer_conditions_text) {
                      <span class="text-danger">
                        &mdash;
                      </span>
                    }
                  </td>
                  <td
                    [class.table-danger]="row['developer_is_danger']"
                    [class.table-warning]="row['developer_is_warning']"
                    title="До этой даты по данному застройщику в ТК СА будут отображены эти условия"
                    >
                    <a [routerLink]="[row.id]">
                      <b>{{ row.developer_date_to }}</b>
                    </a>
                  </td>
                  <td
                    [class.table-danger]="row['developer_is_danger']"
                    [class.table-warning]="row['developer_is_warning']"
                    >
                    @if (row.developer_edited_date) {
                      <a class="text-nowrap" [routerLink]="[row.id]">
                        {{ row.developer_edited_date }} {{ row.developer_edited_author }}
                      </a>
                    }
                  </td>
                }
                @if (!row.developer_date_to) {
                  <td colspan="3"
                    [class.table-danger]="row['developer_is_danger']"
                    [class.table-warning]="row['developer_is_warning']"
                    >
                    <a [routerLink]="[row.id]">
                      [нет данных]
                    </a>
                  </td>
                }
                <td
                  [class.table-danger]="row['complex_is_danger']"
                  [class.table-warning]="row['complex_is_warning']"
                  >
                  <a [routerLink]="[row.id]">
                    @if (row['complex_is_danger']) {
                      <i class="mr-1 text-danger fa fa-fw fa-exclamation-triangle" title="КВ не показаны в ТК!"></i>
                    }
                    @if (row['complex_is_warning']) {
                      <i class="mr-1 text-warning fa fa-fw fa-exclamation-triangle" title="Скоро истечёт срок!"></i>
                    }
                    <span>{{ row['complex_caption'] }}</span>
                  </a>
                </td>
                @if (row.complex_proc) {
                  <td
                    [class.table-danger]="row['complex_is_danger']"
                    [class.table-warning]="row['complex_is_warning']"
                    >
                    @if (row.complex_proc_spn) {
                      <a [routerLink]="[row.id]">
                        <b>{{ row.complex_proc_spn }}%</b>
                      </a>
                    }
                  </td>
                  <td
                    [class.table-danger]="row['complex_is_danger']"
                    [class.table-warning]="row['complex_is_warning']"
                    >
                    @if (row.complex_proc) {
                      <a [routerLink]="[row.id]">
                        <b>{{ row.complex_proc }}%</b>
                      </a>
                    }
                  </td>
                  <td title="До этой даты по данному ЖК в ТК СА будет отображено это КВ"
                    [class.table-danger]="row['complex_is_danger']"
                    [class.table-warning]="row['complex_is_warning']"
                    >
                    <a [routerLink]="[row.id]">
                      <b>{{ row.complex_date_to }}</b>
                    </a>
                  </td>
                  <td
                    [class.table-danger]="row['complex_is_danger']"
                    [class.table-warning]="row['complex_is_warning']"
                    >
                    @if (row.complex_edited_date) {
                      <a class="text-nowrap" [routerLink]="[row.id]">
                        {{ row.complex_edited_date }} {{ row.complex_edited_author }}
                      </a>
                    }
                  </td>
                }
                @if (!row.complex_proc) {
                  <td colspan="4"
                    [class.table-danger]="row['complex_is_danger']"
                    [class.table-warning]="row['complex_is_warning']"
                    >
                    <a [routerLink]="[row.id]">
                      [нет данных]
                    </a>
                  </td>
                }
                <!--          <td>-->
                <!--            <a href="javascript: void(0)" [routerLink]="[row.id]">-->
                <!--              Подробнее-->
              <!--            </a>-->
            <!--          </td>-->
            <td
              [class.table-danger]="row['complex_is_danger']"
              [class.table-warning]="row['complex_is_warning']"
              >
              @if (row['imp_settings_ids'].length > 1) {
                <popover-content #popoverInfo
                  [title]="'XML источники:'"
                  [placement]="'auto'"
                  [closeOnClickOutside]="true"
                  [closeOnMouseOutside]="false">
                  @for (el of row['imp_settings_ids']; track el; let isLast = $last) {
                    <p [class.mb-3]="!isLast"
                      [class.mb-0]="isLast"
                      >
                      <a [routerLink]="['/import/edit', el['id'], 'realization']">{{el.caption}}</a>
                    </p>
                  }
                </popover-content>
                <div [popover]="popoverInfo" title="XML источники">
                  <i class="menu__item-text-icon menu__item-text-icon_sm icon icon_xml-icon mx-2 c-pointer text-danger"
                  ></i>
                </div>
              }
              @if (row['imp_settings_ids'].length === 1) {
                <a [routerLink]="['/import/edit', row['imp_settings_ids'][0]['id'], 'realization']" title="XML источник">
                  <i class="menu__item-text-icon menu__item-text-icon_sm icon icon_xml-icon mx-2"></i>
                </a>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
<div class="alt-pagination pb-5">
  <app-paginator
    [queryParams]="filterColumns"
    [itemsPerPage]="500"
    [itemCount]="count"
    [currentPage]="currentPage"
    [baseUrl]="'/condition/developer'">
  </app-paginator>
</div>
